<template>
  <div>
    <b-nav-form class="search" @submit.prevent="searchCourse">
      <v-autocomplete
        :items="items"
        v-model="item"
        :get-label="getLabel"
        :wait="100"
        :min-len="1"
        :component-item="template"
        @update-items="searchKeys"
        @item-clicked="searchCourse"
        @item-selected="searchCourse"
        :placeholder="placeholderText"
        :auto-select-one-item="false"
        id="search"
        class="search-bar-input"
      >
      </v-autocomplete>
    </b-nav-form>
  </div>
  <!--  <b-nav-form class="search">-->
  <!--    <b-form-input-->
  <!--        size="md"-->
  <!--        class="header-search-bar"-->
  <!--        placeholder="What do you want to learn.."-->
  <!--    ></b-form-input>-->
  <!--    <b-button size="sm" class="my-2 my-sm-0" type="submit">-->
  <!--      <font-awesome-icon icon="search" size="xs" />-->
  <!--    </b-button>-->
  <!--  </b-nav-form>-->
  <!--  </b-navbar-nav>-->
</template>

<script>
import { videoApi } from "../../services/videoApi";
import searchListTemplate from "./SearchListTemplate";
import { customerApi } from "../../services/customerApi";

export default {
  name: "search-courses",
  data() {
    return {
      item: "",
      template: searchListTemplate,
      items: [],
      placeholderText: "What do you want to learn.."
    };
  },
  methods: {
    getLabel(item) {
      if (this.isTeacher) {
        return item.teacher_name;
      } else {
        return item.search_name;
      }
    },
    searchKeys(text) {
      if (this.isTeacher) {
        customerApi.searchTeacher(text).then(res => {
          this.items = res.data;
        });
      } else {
        videoApi.searchKeys(text).then(res => {
          this.items = res.data;
        });
      }
    },
    searchCourse() {
      if (this.isTeacher) {
        this.$router.push({
          path: "/teacher",
          query: {
            teacherId: this.item.teacher_id
          }
        });
      } else {
        this.$router.push({
          path: "/course_description",
          query: { courseId: this.item.course_id }
        });
      }
    }
  },
  props: {
    isTeacher: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (this.isTeacher) {
      this.placeholderText = "Search teacher by Name...";
    } else {
      this.placeholderText = "What do you want to learn...";
    }
  }
};
</script>

<style lang="scss">
.v-autocomplete {
  position: relative;
  .v-autocomplete-input-group {
    .v-autocomplete-input {
      text-rendering: auto;
      color: initial;
      letter-spacing: normal;
      word-spacing: normal;
      text-transform: none;
      text-indent: 0px;
      text-shadow: none;
      display: inline-block;
      text-align: start;
      margin: 0em;
      font: 400 13.3333px Arial;
      margin: 0 auto;
      width: 100%;
      height: 38px;
      padding: 0 35px 0 20px;
      font-size: 14px;
      border: 0px solid #d0cfce;
      outline: none;
      overflow: visible;
      font-family: inherit;
      line-height: inherit;
      -webkit-appearance: textfield;
      background-color: white;
      -webkit-rtl-ordering: logical;
      cursor: text;
      -webkit-border-radius: 6px;
      border-radius: 6px;
      -webkit-appearance: none;
    }
  }
  .v-autocomplete-input-group.v-autocomplete-selected {
    .v-autocomplete-input {
      text-rendering: auto;
      color: initial;
      letter-spacing: normal;
      word-spacing: normal;
      text-transform: none;
      text-indent: 0px;
      text-shadow: none;
      display: inline-block;
      text-align: start;
      margin: 0em;
      font: 400 13.3333px Arial;
      margin: 0 auto;
      width: 100%;
      height: 38px;
      padding: 0 40px 0 20px;
      font-size: 14px;
      outline: none;
      overflow: visible;
      font-family: inherit;
      line-height: inherit;
      -webkit-appearance: textfield;
      background-color: white;
      -webkit-rtl-ordering: logical;
      cursor: text;
    }
  }
  .v-autocomplete-list {
    position: absolute;
    width: 100%;
    text-align: left;
    border: none;
    border-top: none;
    max-height: 400px;
    overflow-y: auto;
    z-index: 4000;
    margin-left: -2px;
    margin-top: 1px;
    border-bottom: 2px solid rgba(128, 128, 128, 0.2);
    .v-autocomplete-list-item {
      cursor: pointer;
      background-color: #fff;
      color: black;
      padding: 10px;
      border-left: 2px solid rgba(128, 128, 128, 0.2);
      border-right: 2px solid rgba(128, 128, 128, 0.2);
      &:last-child {
        border-bottom: none;
      }
      &:hover {
        background-color: #eee;
      }
    }
  }
}
</style>
